<template>
  <v-content>
    <div class="home">
      <h1>Welcome to the Collect App!</h1>
      <div v-if="!loggedIn">
        To use this app you'll need to
        <router-link to="/login">login</router-link>
      </div>
    </div>
  </v-content>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { authComputed } from "../store/helpers.js";

export default {
  name: "Home",
  components: {
    // HelloWorld
  },
  computed: {
    ...authComputed
  }
};
</script>
